﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederUtvekslingDto from '../Models/VeilederUtvekslingDto';

const valgHost = 'a1-valgHost';
const valgVaar = 'a2-valgVaar';
const valgHel = 'a3-valgHel'; 

const varighetValg: RadioButtonValgModel<VeilederUtvekslingDto>[] = [
    {
        id: 'a1', 
        value: valgHost,
        tekst: 'valgHost',
    },
    {
        id: 'a2',
        value: valgVaar,
        tekst: 'valgVaar',
    },
    {
        id: 'a3',
        value: valgHel,
        tekst: 'valgHel',
    }
];

export default {
    valgHost: valgHost,
    valgVaar: valgVaar,
    valgHel: valgHel,
    varighetValg,
};
